import React from 'react';
import './App.css';
import PropTypes from 'prop-types';
import Icon from './Icon.js';

const badge= 'https://itreeware.s3-us-west-2.amazonaws.com/banner/header-avatar-generic.png';
const instagram_Christmas= 'https://instagram.com/a/r/?effect_id=2677825048948934&ch=YmU2NTBhN2YyNjFhZTg4ODg2N2IxMzJmOWQ5NjkzNzI%3D';
const instagram_Garden= 'https://instagram.com/a/r/?effect_id=2677825048948934&ch=YmU2NTBhN2YyNjFhZTg4ODg2N2IxMzJmOWQ5NjkzNzI%3D';
const take_action= 'https://bit.ly/2NyZKaa';



class ShareImage extends React.Component {
  render() {

  return (
  	<div className="thumbnail-container">
  	 <header >
            <a> <img className="favorite_me" src={this.props.liked} alt="Liked" /> </a>
  		<h1> 
  			<a href="http://www.iTreeware.com" target="_blank" rel="noopener noreferrer"> <img className="image" src={this.props.img} alt="img-URL" /> </a>
  			{this.props.loc}
	  	</h1>
	 </header>
 
	<div className="action-links">
		<Icon URL={badge} id= "Adorn" link={instagram_Christmas}  hover="Add Christmas Decorations"/> 
		<Icon URL={badge} id= "Grow" link={instagram_Garden} hover="Add Garden Improvements"/> 
		<Icon URL={badge} id= "Act" link={take_action} hover="Take Action for Change"/> 
	</div>
   
        <h2> {this.props.title}  </h2>
        <p className="thumb-desc">
          {this.props.desc}
        </p>
      
    </div>
  );
}}
ShareImage.propTypes = {
  image:PropTypes.string.isRequired,
};

export default ShareImage;

